import { render, staticRenderFns } from "./UnityForm.vue?vue&type=template&id=1855e948&"
import script from "./UnityForm.vue?vue&type=script&lang=js&"
export * from "./UnityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports